// extracted by mini-css-extract-plugin
export var root = "Swatch-module--root--sonxx";
export var circle = "Swatch-module--circle--YuXvf";
export var isActive = "Swatch-module--isActive--PVWaU";